import React from 'react'
import { Adsense } from '@ctrl/react-adsense';
// import './css/AdsenseStylesheet.css';

function AdsenseExample() {
    return (
        <Adsense
            client="ca-pub-1906210557111803"
            slot="7290986713"
            style={{ display: 'block' }}
            layout="in-article"
            format="fluid"
        />
    )

}

export default AdsenseExample;